import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const BenefitsFill: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Vector"
        d="M19.3282 13.9728C18.8076 13.4522 17.9633 13.4522 17.4426 13.9728L16.4998 14.9158C15.4584 15.9571 13.77 15.9571 12.7286 14.9158C11.6872 13.8743 11.6872 12.1858 12.7286 11.1444L20.2361 3.63491C23.0413 3.00031 26.1009 3.77501 28.2849 5.95901C31.5108 9.18482 31.662 14.321 28.7388 17.7259L25.9278 20.5726L19.3282 13.9728ZM4.71468 5.95901C7.61253 3.06114 12.052 2.64445 15.3932 4.70889L10.8429 9.25883C8.76014 11.3416 8.76014 14.7186 10.8429 16.8014C12.8626 18.821 16.0992 18.8822 18.1925 16.985L18.3854 16.8014L24.0422 22.4582L18.3854 28.115C17.344 29.1564 15.6556 29.1564 14.6142 28.115L4.71468 18.2155C1.33013 14.831 1.33013 9.34354 4.71468 5.95901Z"
        fill={color}
      />
    </svg>
  );
};

export default BenefitsFill;
